import AccomplishmentCard from "views/Builder/components/accomplishments/cards";

import badgeImage from "../assets/ios-guild-badge.png";
import backgroundImage from "../assets/ios-guild-background.png";

export const IOSGuildCard = () => (
  <AccomplishmentCard
    badgeImage={badgeImage}
    backgroundImage={backgroundImage}
    title="iOS guild member"
    description="An experienced iOS developer advancing high-quality, maintainable mobile apps."
  />
);
